module.exports = __webpack_public_path__ + "img/BLR.ae43644e.svg";